import { Group as MantineGroup, GroupProps } from '@mantine/core';

export type IGroupProps = GroupProps;

/** @registry Design-layer pass-through over Mantine Group; import this instead of @mantine/core Group outside src/design. */
export const Group = MantineGroup;
